import {createContext} from 'react'

const CatRolesContext = createContext()

export default CatRolesContext